import { createSelector } from "reselect";
const selector = (state) => state.data;

export default createSelector([selector], (data) => data);